export default __webpack_public_path__ + "static/media/format-underline.2288ecff.svg";